import { useFormContext } from 'react-hook-form'
import { EnvVariableEditor } from '@/components/sv/env-variable-editor'
import { H4 } from '@/components/sv/typographies'
import { Checkbox } from '@/components/ui/checkbox'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import type { CreateStaticSiteFormValues } from '@/routes/static-sites/create-static-site/form/schema'

export const EnvVars = () => {
  const form = useFormContext<CreateStaticSiteFormValues>()
  const isPreviewEnabled = form.watch('isPreviewEnabled')

  return (
    <>
      <H4>Environment variables</H4>
      {isPreviewEnabled ? (
        <div className="flex flex-col gap-1">
          <FormField
            control={form.control}
            name="isEnvVarProduction"
            render={({ field }) => {
              return (
                <FormItem>
                  <div className="flex flex-row items-center gap-2">
                    <FormControl>
                      <Checkbox
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </FormControl>
                    <FormLabel className="text-sm font-normal">
                      Production
                    </FormLabel>
                  </div>
                  <FormMessage />
                </FormItem>
              )
            }}
          />
          <FormField
            control={form.control}
            name="isEnvVarPreview"
            render={({ field }) => {
              return (
                <FormItem className="flex flex-row items-center gap-2">
                  <FormControl>
                    <Checkbox
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormLabel className="text-sm font-normal">Preview</FormLabel>
                </FormItem>
              )
            }}
          />
        </div>
      ) : null}

      <EnvVariableEditor />
    </>
  )
}
